module.exports = __webpack_public_path__ + "static/media/tokyo2.c5694014.jpg";